import React from 'react';
import clsx from 'clsx';
import Icon from '../Icon';
import { ICell } from './types';

const CellCommon = ({
  title,
  description,
  children,
  inner,
  arrow,
  marginTop,
  marginBottom,
  onClick,
  to,
  as: Comp = 'div',
  disabled,
  className = '',
}: ICell) => {
  // arrow 优先，没有 arrow 参数时，以 onClick 为主
  const isArrow = typeof arrow === 'boolean' ? arrow : !!onClick || !!to;

  let restProps = {};

  if (!disabled) {
    restProps = {
      onClick,
      to,
    };
  }

  return (
    <Comp
      className={clsx('cell', className, {
        inner,
        disabled,
        'cursor-pointer': arrow || !!onClick || !!to,
      })}
      style={{ marginTop, marginBottom }}
      {...restProps}
    >
      <div className="cell-body">
        <div className="title">{title}</div>
        {!!description && <div className="description">{description}</div>}
      </div>
      <div className="cell-footer">
        <div className="cell-footer-content">{children}</div>
        {isArrow && (
          <div className="arrow">
            <Icon className="neuter600" type="arrow-right" fontSize={20} />
          </div>
        )}
      </div>
    </Comp>
  );
};

export default CellCommon;
